export const WarningXl: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    fill="none"
    viewBox="0 0 60 60"
  >
    <g clipPath="url(#clip0_17667_39035)">
      <path fill="#D6453B" d="M30 32.8v-9.35z"></path>
      <path
        stroke="#D6453B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M30 32.8v-9.35"
      ></path>
      <path
        fill="#D6453B"
        d="M29.494 40c-.828 0-1.5.672-1.494 1.5a1.5 1.5 0 1 0 1.494-1.5"
      ></path>
      <path
        stroke="#D6453B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="m35.076 10.348 19.147 33.51c2.225 3.895-.587 8.742-5.072 8.742H10.856c-4.488 0-7.3-4.848-5.073-8.742l19.148-33.51c2.242-3.928 7.902-3.928 10.145 0"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_17667_39035">
        <path fill="#fff" d="M0 0h60v60H0z"></path>
      </clipPath>
    </defs>
  </svg>
);
